import { Box, Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { FalseIcon, TrueIcon } from "../../assets/icons/MUI/NetworkIcons";

type Props = {
  compareUsersList: { items: any[] };
  label: string;
  dataKey: string;
  isLastRow: boolean;
};

const CompareRowBoolean = ({ compareUsersList, label, dataKey }: Props) => {
  return (
    <Box
      key={dataKey}
      sx={{
        display: "flex",
        padding: "17px 27px",
        gap: "66px",
      }}
    >
      <Box sx={{ width: "237px" }}>
        <Typography
          variant="body14Bold"
          sx={{
            fontWeight: 700,
            color: colors.Dark1000,
          }}
        >
          {label}
        </Typography>
      </Box>
      {compareUsersList?.items?.map((user: any) => (
        <Box sx={{ width: "148px", textAlign: "center" }}>
          <Typography
            variant="body14Regular"
            sx={{
              color: colors.Dark1000,
            }}
          >
            {user[dataKey] ? <TrueIcon style={{ fill: "none" }} /> : <FalseIcon style={{ fill: "none" }} />}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CompareRowBoolean;
